document.addEventListener('DOMContentLoaded', function () {

  function initBuyButtons() {

    if (!window.ShopifyBuy || !window.ShopifyBuy.UI) return;

    var client = ShopifyBuy.buildClient({
      domain: 'alexandria-fragrances.myshopify.com',
      storefrontAccessToken: '127b057bfdfb3ecdaffe1017cbb527fd',
    });

    ShopifyBuy.UI.onReady(client).then(function (ui) {

      document.querySelectorAll('.shopify-buy-button').forEach(function (el) {

        if (el.dataset.initialized === 'true') return;

        el.dataset.initialized = 'true';

        var productId = el.dataset.productId;

        ui.createComponent('product', {
          id: productId,
          node: el,
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: {
            "product": {
                "styles": {
                "product": {
                    "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0",
                    "margin-bottom": "50px"
                    },
                    "text-align": "left"
                },
                "title": {
                    "font-family": "Arvo, serif",
                    "font-size": "26px",
                    "color": "#090203"
                },
                "button": {
                    "font-family": "Josefin Slab, sans-serif",
                    "font-weight": "bold",
                    "font-size": "18px",
                    "padding-top": "17px",
                    "padding-bottom": "17px",
                    ":hover": { "background-color": "#0f0305" },
                    "background-color": "#090203",
                    ":focus": { "background-color": "#0f0305" },
                    "border-radius": "0px",
                    "padding-left": "84px",
                    "padding-right": "84px"
                },
                "quantityInput": {
                    "font-size": "18px",
                    "padding-top": "17px",
                    "padding-bottom": "17px"
                },
                "price": {
                    "font-family": "Arvo, serif",
                    "font-size": "18px",
                    "color": "#090203"
                },
                "compareAt": {
                    "font-family": "Arvo, serif",
                    "font-size": "15.3px",
                    "color": "#090203"
                },
                "unitPrice": {
                    "font-family": "Arvo, serif",
                    "font-size": "15.3px",
                    "color": "#090203"
                },
                "description": {
                    "font-family": "Avant Garde, sans-serif",
                    "color": "#090203"
                }
                },
                "layout": "horizontal",
                "contents": {
                "img": false,
                "imgWithCarousel": true,
                "button": false,
                "buttonWithQuantity": true,
                "description": true
                },
                "width": "100%",
                "text": { "button": "Add to cart" },
                "googleFonts": ["Arvo", "Josefin Slab"]
            },

            "modalProduct": {
                "contents": {
                "img": false,
                "imgWithCarousel": true,
                "button": false,
                "buttonWithQuantity": true
                },
                "styles": {
                "product": {
                    "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0px",
                    "margin-bottom": "0px"
                    }
                },
                "button": {
                    "font-family": "Josefin Slab, sans-serif",
                    "font-weight": "bold",
                    "font-size": "18px",
                    "padding-top": "17px",
                    "padding-bottom": "17px",
                    ":hover": { "background-color": "#0f0305" },
                    "background-color": "#090203",
                    ":focus": { "background-color": "#0f0305" },
                    "border-radius": "0px",
                    "padding-left": "84px",
                    "padding-right": "84px"
                }
                },
                "googleFonts": ["Arvo", "Josefin Slab"]
            },

            "cart": {
                "styles": {
                "button": {
                    "font-family": "Josefin Slab, sans-serif",
                    "font-weight": "bold",
                    "font-size": "18px",
                    "padding-top": "17px",
                    "padding-bottom": "17px",
                    ":hover": { "background-color": "#0f0305" },
                    "background-color": "#090203",
                    ":focus": { "background-color": "#0f0305" },
                    "border-radius": "0px"
                }
                },
                "text": {
                "total": "Subtotal",
                "button": "Checkout"
                },
                "popup": false,
                "googleFonts": ["Josefin Slab"]
            },

            "toggle": {
                "styles": {
                "toggle": {
                    "font-family": "Josefin Slab, sans-serif",
                    "font-weight": "bold",
                    "background-color": "#090203",
                    ":hover": { "background-color": "#0f0305" },
                    ":focus": { "background-color": "#0f0305" }
                },
                "count": { "font-size": "18px" }
                },
                "googleFonts": ["Josefin Slab"]
            }
          }
        });

      });

    });
  }

  function loadSDK(callback) {
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
    document.head.appendChild(script);
    script.onload = callback;
  }

  if (window.ShopifyBuy && window.ShopifyBuy.UI) {
    initBuyButtons();
  } else {
    loadSDK(initBuyButtons);
  }

});